<div class="nag-header">
	Domain Value Customization
</div>
<div class="nag-content">
	<div class="content-left">
		<div class="header-line">Category</div>
		<!-- <div class="subheader-line nag-cate-type">
			<select name="nagCateType" [(ngModel)]="selectedNagCateType" (ngModelChange)="onChangeNagCateType()">
				<option *ngFor="let type of nagCateTypes" [ngValue]="type">{{type.label}}</option>
			</select>
		</div> -->
		<div class="nag-cates">
			<ng-container *ngFor="let cate of nagCates">
				<!-- *ngIf="cate.isSpatial===selectedNagCateType.isSpatial" -->
				<div [ngClass]="{'selected-cate': selectedCate===cate}" (click)="selectCate(cate)">{{cate.name}}</div>
			</ng-container>
		</div>
	</div>
	<div class="content-middle">
		<div class="header-line">
			Standard Name
			<div class="nag-filter">
				<input [(ngModel)]="filterStr" (ngModelChange)="changeFilter()" placeholder="Search standard names">
			</div>
			<div *ngIf="showCountyFilter" class="nag-county">
				<label>County </label>
				<select name="counties" [(ngModel)]="filterCounty" (ngModelChange)="filterByCounty()">
					<option *ngFor="let county of availableCounties" [ngValue]="county">{{county.name}}</option>
				</select>
			</div>
			<div class="nag-state">
				<label>State </label>
				<select name="nagState" [(ngModel)]="selectedState">
					<option *ngFor="let state of stateList" [ngValue]="state">{{state.code}}</option>
				</select>
			</div>
			<!-- <div class="nag-download">
				<button class="button-general" (click)="download()">Download</button>
			</div> -->
		</div>
		<div class="nag-detail" (contextmenu)="onTableParentContextmenu($event)">
			<app-common-datagrid
				#namesTable
				[id]="tableElemId"
				[columns]="columns"
				[rows]="standardNames"
				[selectedRows]="selectedRows"
				[selectionType]="'single'"
				[isPaging]="true"
				[pageSize]="paging.pageSize"
				[isPagingOnTop]="true"
				[totalNum]="totalCount"
				(paging)="setPage($event)"
				(select)="onSelectStandardName()"
				(tableContextmenu)="onTableContextmenu($event)">
			</app-common-datagrid>
		</div>
	</div>
	<div class="content-right">
		<div class="header-line alias-title">Alias</div>
		<div class="nag-alias">
			<div class="alias-list" (contextmenu)="onAliasContextmenu($event)">
				<div *ngFor="let ali of aliasNames" class="alias-item" (contextmenu)="onAliasContextmenu($event, ali)">
					<div class="alias-item-ownerlevel" title="{{ali.cusNameShort}}">
						<ng-container [ngSwitch]="ali.cusLevel">
							<i *ngSwitchCase="0" class="glyphicons glyphicons-cogwheel"></i>
							<!-- <img *ngSwitchCase="1" [src]="stateSvgSrc">
							<img *ngSwitchCase="2" [src]="countySvgSrc">
							<img *ngSwitchCase="3" [src]="citySvgSrc"> -->
							<mat-icon *ngSwitchCase="1" svgIcon="icon-builfing-gov2"></mat-icon>
							<mat-icon *ngSwitchCase="2" svgIcon="icon-building-gov"></mat-icon>
							<mat-icon *ngSwitchCase="3" svgIcon="icon-flag"></mat-icon>
						</ng-container>
					</div>
					<div class="alias-item-name">{{ali.name}}</div>
					<div *ngIf="optionsEnable.aliasEdit(ali)" class="alias-item-op" (click)="editAlias({item:ali})">
						<i class="glyphicons glyphicons-edit" ></i>
					</div>
				</div>
				<div *ngIf="canAddAlias" class="alias-item">
					<div class="alias-item-name"></div>
					<div class="alias-item-op">
						<i class="glyphicons glyphicons-plus" (click)="addAlias()"></i>
					</div>
				</div>
			</div>
		</div>
		<div [hidden]="hideMap" class="nag-map" [id]="mapId"></div>
	</div>
</div>

<ng-template #placeTypeTempl let-row="row" let-column="column" let-index="index">
	<div *ngIf="row[placeTypesCol]&&(row[placeTypesCol].indexOf(column.prop)>-1)">
		<i class="glyphicons glyphicons-ok"></i>
	</div>
</ng-template>
<ng-template #ownerCellTempl let-row="row">
	<div class="owner-level-cell" [ngSwitch]="row[ownerLevelCol]" title="{{row[cusNameShortCol]}}">
		<i *ngSwitchCase="0" class="glyphicons glyphicons-cogwheel"></i>
		<!-- <img *ngSwitchCase="1" [src]="stateSvgSrc">
		<img *ngSwitchCase="2" [src]="countySvgSrc">
		<img *ngSwitchCase="3" [src]="citySvgSrc"> -->
		<mat-icon *ngSwitchCase="1" svgIcon="icon-builfing-gov2"></mat-icon>
		<mat-icon *ngSwitchCase="2" svgIcon="icon-building-gov"></mat-icon>
		<mat-icon *ngSwitchCase="3" svgIcon="icon-flag"></mat-icon>
	</div>
</ng-template>
<ng-template #operationTempl let-row="row">
	<div class="row-operation">
		<i *ngIf="optionsEnable.standardEdit(row)" class="glyphicons glyphicons-edit" (click)="editStandardName({item:row})"></i>
	</div>
</ng-template>

<context-menu #StandardOptions>
	<ng-template contextMenuItem [enabled]="optionsEnable.standardAdd" (execute)="addStandardName()">Add a Standard Name</ng-template>
	<ng-template contextMenuItem [enabled]="optionsEnable.standardEdit" (execute)="editStandardName($event)">Edit</ng-template>
	<ng-template contextMenuItem [enabled]="optionsEnable.standardEdit" (execute)="deleteStandardName($event)">Delete</ng-template>
	<ng-template contextMenuItem [enabled]="optionsEnable.aliasAdd" (execute)="addAlias()">Add an Alias</ng-template>
</context-menu>
<context-menu #AliasOptions>
	<ng-template contextMenuItem [enabled]="optionsEnable.aliasAdd" (execute)="addAlias()">Add an Alias</ng-template>
	<ng-template contextMenuItem let-item [enabled]="optionsEnable.aliasEdit" (execute)="editAlias($event)">Edit</ng-template>
	<ng-template contextMenuItem [enabled]="optionsEnable.aliasEdit" (execute)="deleteAlias($event)">Delete</ng-template>
</context-menu>
